// Shared markdown rendering for report/file content (BioInterpreter
// responses, viewed .md files). Plain react-markdown only understands
// CommonMark — GFM pipe tables (the format BioInterpreter and every other
// markdown source in this app actually emits) silently fall back to raw
// paragraph text without remarkGfm, which is what made tables look
// "broken up" in the UI while looking fine in any GFM-aware viewer
// (GitHub, VS Code, pandoc-rendered PDF). remarkGfm plus real <table>
// styling makes the in-app view match those.
import React from "react";
import { Box } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const components = {
  table: (props) => (
    <table
      {...props}
      style={{
        borderCollapse: "collapse",
        width: "100%",
        border: "1px solid #CBD5E1",
        margin: "0.75rem 0",
        fontSize: "0.875rem",
      }}
    />
  ),
  thead: (props) => <thead {...props} style={{ backgroundColor: "#F8FAFC" }} />,
  th: (props) => (
    <th
      {...props}
      style={{
        border: "1px solid #CBD5E1",
        padding: "6px 10px",
        textAlign: "left",
        color: "#334155",
        fontWeight: 700,
      }}
    />
  ),
  td: (props) => (
    <td {...props} style={{ border: "1px solid #CBD5E1", padding: "6px 10px", verticalAlign: "top" }} />
  ),
  h1: ({ children, ...props }) => (
    <h1 {...props} style={{ fontSize: "1.4rem", margin: "1rem 0 0.5rem", color: "#1E293B" }}>{children}</h1>
  ),
  h2: ({ children, ...props }) => (
    <h2 {...props} style={{ fontSize: "1.2rem", margin: "1rem 0 0.5rem", color: "#1E293B" }}>{children}</h2>
  ),
  h3: ({ children, ...props }) => (
    <h3 {...props} style={{ fontSize: "1.05rem", margin: "0.85rem 0 0.4rem", color: "#1E293B" }}>{children}</h3>
  ),
  p: (props) => <p {...props} style={{ margin: "0.5rem 0", lineHeight: 1.6, color: "#334155" }} />,
  li: (props) => <li {...props} style={{ margin: "0.2rem 0", lineHeight: 1.6, color: "#334155" }} />,
  code: ({ inline, ...props }) =>
    inline ? (
      <code
        {...props}
        style={{
          backgroundColor: "#F1F5F9",
          border: "1px solid #E2E8F0",
          borderRadius: 4,
          padding: "0 4px",
          fontSize: "0.85em",
        }}
      />
    ) : (
      <code {...props} />
    ),
  pre: (props) => (
    <pre
      {...props}
      style={{
        backgroundColor: "#F1F5F9",
        border: "1px solid #E2E8F0",
        borderRadius: 6,
        padding: "10px 12px",
        overflowX: "auto",
        fontSize: "0.85em",
      }}
    />
  ),
  blockquote: (props) => (
    <blockquote
      {...props}
      style={{ margin: "0.5rem 0", padding: "0 0.85rem", borderLeft: "3px solid #CBD5E1", color: "#64748B" }}
    />
  ),
};

export default function MarkdownRenderer({ children, sx }) {
  return (
    <Box sx={{ overflowX: "auto", ...sx }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </Box>
  );
}
